import React, { useState, useEffect } from 'react'
// ** React Imports
import { Outlet } from "react-router-dom"
import { Clipboard, BarChart, Search } from "react-feather"
// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "@layouts/VerticalLayout"
import { isUserLoggedIn } from "@utils"
import { useSelector } from "react-redux"
import { DefaultConfig } from '../settings/config'

// import themeConfig from '../configs/themeConfig'
// ** Menu Items Array
// import navigation from "@src/navigation/vertical"

const VerticalLayout = (props) => {
  const getUserRole = DefaultConfig().getUserRole

  const stores = useSelector((state) => state.commonreducerSlice)
  const [menusData, setMenuData] = useState([])

  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  useEffect(() => {
    if (isUserLoggedIn()) {
      if (JSON.parse(isUserLoggedIn())?.isEmployee) {
        let enableRoute = false
        let userManagementRoute = false
        const userData = JSON.parse(localStorage.getItem('userData'))
        const userRoles = userData && userData.userRoles
        if (userRoles) {
          const findRole = userRoles.find(find => (find.rId === 1 || find.rId === 6 || find.rId === 7))
          if (findRole) {
            enableRoute = true
          }

          const userManagementRole = userRoles.find(find => (find.rId === 1 || find.rId === 4 || find.rId === 5))
          if (userManagementRole) {
            userManagementRoute = true
          }
        }
        if (enableRoute || userManagementRoute) {
          const empMenuData = JSON.parse(JSON.stringify(stores?.empMenuData))

          if (enableRoute) {
            const findIndex = empMenuData.findIndex(find => find.id === 'appSettings')
            if (findIndex >= 0) {
              empMenuData[findIndex]['show'] = true
            }
          }

          if (userManagementRoute) {
            const findIndex = empMenuData.findIndex(find => find.id === 'userManagement')
            if (findIndex >= 0) {
              empMenuData[findIndex]['show'] = true
            }
          }

          if (!getUserRole()) {
            const data = empMenuData.filter(x => x.id !== "dashboard")
            setMenuData(data)
          } else {
            setMenuData(empMenuData)
          }
        } else {
          const data = stores?.empMenuData.filter(x => x.id !== "dashboard")
          setMenuData(data)
        }
      } else {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const data = userData && userData?.companies
        let cusMenuData = stores?.cusMenuData
        // Condition 1: All numbers
        const hasAllNumbers = data.some(item => /^\d+$/.test(item.agentId))
        // Condition 2: Starts with MTTCA
        const hasMTTCA = data.some(item => item.agentId?.startsWith("MTTCA"))
        // Condition 3: Starts with SFR
        const hasSFR = data.some(item => item.agentId?.startsWith("SFR"))
        // Condition 4: Starts with MC
        const hasMC = data.some(item => item.agentId?.startsWith("MC"))

        cusMenuData = cusMenuData.map(menuItem => {
            if (menuItem.id === "filingAgent" && hasAllNumbers) {
                return { ...menuItem, show: true }
            }
            if (menuItem.id === "trainingCenter" && hasMTTCA) {
                return { ...menuItem, show: true }
            }
            if (menuItem.id === "seafearerStudent" && hasSFR) {
                return { ...menuItem, show: true }
            }
            if (menuItem.id === "medicalClinics" && hasMC) {
                return { ...menuItem, show: true }
            }
            return menuItem
        })
        setMenuData(cusMenuData)
      }
    }
  }, [isUserLoggedIn(), stores?.menuBoolean, stores?.cusSpinner])

  return (
    <Layout menuData={menusData} {...props}>
      <Outlet />
    </Layout>
  )
}

export default VerticalLayout
